<section>
  <div class="mb-2">
    <div class="row">
      <p>Para realizar el proceso de importación de Lista de Precios, descargue la guía y siga los pasos:</p>
    </div>
    <div class="row">
      <div class="col field-type mt-2">
        <app-custom-select [internalValue]="1" [labelText]="'Importar'" [list]="listTypeImport" [required]="true"
          (onChangeSelect)="changeTypeSelected($event)"></app-custom-select>
      </div>
      <div class="col field-guide d-flex align-items-end">
        <app-custom-button [title]="'Descargar Guía'" [label]="'Descargar Guía'" [severity]="'success'" [width]="'7rem'"
          (onClick)="downloadGuideImport()"></app-custom-button>
      </div>
      <div class="col field-file d-flex flex-row justify-content-end align-items-end gap-2 mt-2">
        <input type="file" id="fileImport" (change)="getNameFile($event)"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" hidden />
        <app-custom-button [title]="'Seleccionar archivo'" [label]="'Seleccionar archivo'" [variant]="undefined"
          [width]="'8.5rem'" (onClick)="attach()"></app-custom-button>
        <p class="mb-1">{{nameFile}}</p>
      </div>
      <div class="col import-btn d-flex justify-content-end align-items-end gap-2 mt-2">
        <app-custom-button [title]="'Importar'" [label]="'Importar'" [variant]="undefined" [severity]="'success'"
          (onClick)="importPriceList()"></app-custom-button>
      </div>
    </div>
    <div class="row">
      <div id="list" *ngIf="visibleTxt">
        <h6>Lista de Errores y Alertas</h6>
        <p>Total errores: {{priceListAlerts.length}}</p>
        <div id="container-alerts" *ngFor="let priceListAlert of priceListAlerts">
          <p [ngClass]="errorPriceList == 1 ? 'message-error' : 'message-alert'">
            {{priceListAlert.message}}
          </p>
        </div>
      </div>
      <div class="row" *ngIf="visibleTxt">
        <div class="d-flex justify-content-end">
          <app-custom-button [title]="'Exportar'" [label]="'Exportar'" [icon]="'pi pi-file-export'" [width]="'5.5rem'"
            (onClick)="downloadErrorsTxt()"></app-custom-button>
        </div>
      </div>
    </div>
  </div>
</section>